import { BACKEND_URL as SITE_URL } from '@/config/api';
import { Helmet } from 'react-helmet-async';

const DEFAULT_OG_IMAGE = '/og-image.webp';

export default function SEO({ 
  title, 
  description, 
  image = DEFAULT_OG_IMAGE,
  url,
  type = 'website'
}) {
  const fullTitle = title ? `${title} | Microsafe` : 'Microsafe - Algeovervåking for havbruk';
  const fullUrl = url ? `${SITE_URL}${url}` : SITE_URL;
  const fullImage = image.startsWith('http') ? image : `${SITE_URL}${image}`;
  
  return (
    <Helmet>
      {/* Basic */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      
      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:site_name" content="Microsafe" />
      <meta property="og:locale" content="nb_NO" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImage} />
    </Helmet>
  );
}
